import React, { useState } from 'react';
import back_icn_btn from '../../../assets/Demat/back_icn_btn.svg';
import './CreateDemat.css';

import DematDashboard from './DematDashboard';
import DematList from './DematList';

const CreateDemat = ({ GotTOCreateDmata, isback, isfromCSC, referrer }) => {
  const [step, setstep] = useState(1);
  const [referal, setReferal] = useState(referrer);
  const [showBackground, setShowBackground] = useState(true);

  const nextStepDemat = () => {
    setstep(step + 1);
  };
  const stepBack = () => {
    if (step - 1 <= 0) {
      // prevStep()
    } else {
      setstep(step - 1);
    }
  };

  const showcomponent = () => {
    setShowBackground(true);
  };

  const hidecomponent = () => {
    setShowBackground(false);
  };

  const renderDemat = () => {
    switch (step) {
      case 1:
        return (
          <DematDashboard
            nextStep={nextStepDemat}
            referrer={referal}
            showcomponent={showcomponent}
            hidecomponent={hidecomponent}
          />
        );
      case 2:
        return <DematList jsondata={json} />;
    }
  };

  let json = [
    {
      name: 'ACML Capital Markets Limited',
    },
    {
      name: 'Acumen Capital Market (India) Limited',
    },
    {
      name: 'Adroit Financial Services Private Limited',
    },
    {
      name: 'Amrapali Capital and Finance Services Limited',
    },
    {
      name: 'Anand Rathi Share and Stock Brokers Limited',
    },
    {
      name: 'Arihant Capital Markets Limited',
    },
    {
      name: 'Ashlar Securities Private Limited',
    },
    {
      name: 'Astha Credit and Securities Private Limited',
    },
    {
      name: 'Aum Capital Market Private Limited',
    },
    {
      name: 'Axis Bank Limited',
    },
  ];

  return (
    <div
      className='container mx-auto mt-5 leftsidebox'
      style={{ display: showBackground ? 'block' : 'none' }}
    >
      <div className='row'>
        <div className='headerdiv d-flex justify-content-between'>
          <div className='headerName'>
            <h3>Create Demat</h3>
            <h5>Select a Broker to create a new Demat account</h5>
          </div>
          {isback && !isfromCSC && step === 1 && (
            <div className='headerBtn'>
              <button
                type='button'
                name='button'
                className='  btncolor small-btn'
                onClick={() => GotTOCreateDmata(2)}
              >
                <img src={back_icn_btn} /> Back
              </button>
            </div>
          )}
          {step === 2 && (
            <div className='headerBtn'>
              <button
                type='button'
                name='button'
                className='  btncolor small-btn'
                onClick={() => stepBack()}
              >
                <img src={back_icn_btn} /> Back
              </button>
            </div>
          )}
        </div>
        <div className='container mx-auto'>
          <div className=' dematicons'>{renderDemat()}</div>
        </div>
      </div>
    </div>
  );
};
export default CreateDemat;
